<template>
  <a-config-provider :locale="arcoLocale">
    <template #empty>
      <empty />
    </template>
    <overlay-provider>
      <router-view />
    </overlay-provider>
  </a-config-provider>
</template>

<script setup>
import usePhoneAuth from '@/compositions/usePhoneAuth';
import useAuth from '@/compositions/useAuth';
import { useAppStore } from '@/store/app';
import { arcoLocale } from '@/i18n';
import { useDocumentVisibility } from '@/compositions/useDocumentVisibility';
import { firstScreenReport } from '@/common/utils/initialize';
import usePearConfig from '@/compositions/usePearConfig';
import { Modal } from '@arco-design/web-vue';
import { useI18n } from 'vue-i18n';
import { isBigolive, isPartyHero } from './common/utils';
import nativeApi from '@bigo/nativeapi-bigo';

const { init, showUnauthorizedModal, clearTimer } = useAuth();
const phoneAuth = usePhoneAuth();
const appStore = useAppStore();
const { t } = useI18n();

const { fetchPearConfig } = usePearConfig();
let initVersion = '';

init();

useDocumentVisibility({
  onVisible: () => {
    init();
  },
  onHidden: () => {
    clearTimer();
  },
});

onMounted(async () => {
  // partyHero 皮肤包下修改页面标题（在 mounted 后执行，确保皮肤包已注入完成）
  if (isPartyHero() && isBigolive) {
    document.title = 'PartyHero Agency OSS';
    // 设置原生导航栏标题（仅在 nativeApi 支持该方法时调用）
    nativeApi
      .setWebViewTitle({ text: isPartyHero() ? 'PartyHero Agency OSS' : 'BIGO LIVE Agency OSS' })
      .catch((err) => {
        console.log(err);
      });
  }
  firstScreenReport();
  const res = await fetchPearConfig();
  initVersion = res?.config?.version || '';
  setInterval(async () => {
    const res2 = await fetchPearConfig();
    const { version, isUpdate } = res2?.config || {};
    if (initVersion && version && initVersion !== version && isUpdate === 1) {
      initVersion = version;
      Modal.info({
        title: t('lang1456'),
        content: t('lang1455'),
        onOk: () => {
          window.location.reload();
        },
      });
    }
  }, 10000);
});

onBeforeUnmount(() => {
  clearTimer();
});

// 监听是否需要弹出手机验证
watch(
  () => appStore.phoneAuthCnt,
  () => {
    phoneAuth.show();
  },
);

// 监听是否需要弹出登录失效的提示
watch(
  () => appStore.tokenErrCnt,
  () => {
    phoneAuth.close();
    showUnauthorizedModal();
  },
);
</script>
